import * as React from 'react';
import { Box, Tag, Divider, TextButton } from '@wix/design-system';
import { ArrowLeftSmall } from '@wix/wix-ui-icons-common';
import type { ExternalComponentProps } from '../types';
import {
  useEssentials,
  withEssentialsContext,
} from '../../contexts/essentials-context';

export type Subcategory = {
  id: string;
  name: string;
  slug: string;
  parentSlug: string;
  parentName: string;
};
export interface BreadcrumbsProps extends ExternalComponentProps {
  subCategories: Subcategory[];
  onBack?(): void;
  onTagClick(
    categorySlug: string,
    subCategory: string,
    label: 'category' | 'sub_category',
    location?: 'top_page' | 'side_category_page',
  ): void;
}

function BreadcrumbsComp({
  subCategories,
  onBack,
  onTagClick,
}: BreadcrumbsProps) {
  const { t } = useEssentials();
  return (
    <Box dataHook="breadcrumbs">
      {onBack && (
        <>
          <Box>
            <TextButton
              size="small"
              dataHook="back-button"
              weight="normal"
              skin="standard"
              onClick={onBack}
              prefixIcon={<ArrowLeftSmall />}
            >
              {t('marketplace.go-back.button')}
            </TextButton>
          </Box>

          <Box margin="0px 12px 0px 12px">
            <Divider direction="vertical" />
          </Box>
        </>
      )}
      {subCategories.length > 0 && (
        <>
          <Box verticalAlign="middle" gap="6px">
            {subCategories.map((subcategory) => (
              <Tag
                dataHook={`tag-${subcategory.id}`}
                id={subcategory.slug}
                theme="lightOutlined"
                removable={false}
                size="tiny"
                key={subcategory.slug}
                onClick={() =>
                  onTagClick(
                    subcategory.parentSlug,
                    subcategory.slug,
                    'sub_category',
                    'top_page',
                  )
                }
              >
                {subcategory.name}
              </Tag>
            ))}
          </Box>
        </>
      )}
    </Box>
  );
}
export const Breadcrumbs = withEssentialsContext(BreadcrumbsComp);
